







































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { DisignPlan } from '@core/model/disign/DisignPlan'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component
export default class DisignHome extends Vue {
  @inject()
  private $api: API

  disignPlans: DisignPlan[] = []

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get plans () {
    return this.disignPlans
  }

  titleCaseName (kebabName) {
    return kebabName.split('-')
      .slice(0, kebabName.split('-').length - 1)
      .map(word => {
        return word.slice(0, 1).toUpperCase() + word.slice(1)
      })
      .join(' ')
  }

  planInterval (kebabName) {
    const interval = kebabName.split('-').at(-1)
    return interval.slice(0, 1).toUpperCase() + interval.slice(1)
  }

  renameType (type) {
    if (type === 'non_biometric') {
      return 'CLASSIC'
    }

    return type.toUpperCase()
  }

  async mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
    this.retrieveDisignPlans()
  }

  async activatePlan (plan: DisignPlan) {
    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: 'Switching signing mode may take up to 24 hours to take effect. Proceed?'
    })

    if (isConfirm) {
      const activated = await this.$api.esign.activatePlan({
        name: plan.type
      })

      if (activated.status) {
        this.uiService.alert.show({
          type: 'success',
          message: `${this.renameType(plan.type)} successfully triggered.`
        })

        this.retrieveDisignPlans()
      } else {
        this.uiService.alert.show({
          type: 'error',
          message: `Error: ${activated.error}.`
        })
      }
    }
  }

  async retrieveDisignPlans () {
    this.disignPlans = []
    const rawDisignPlans = await this.$api.esign.reqEQuota({})
    if (rawDisignPlans.quota) {
      rawDisignPlans.quota.map(plan => {
        const disignPlan = new DisignPlan()
        Object.assign(disignPlan, disignPlan.extractData(plan))
        this.disignPlans.push(disignPlan)
      })
    }
  }
}
